import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export const PAGE_SIZE = 25;

const PAGE_SIZES = [10, 25, 50, 100];

export const AdminPagination = ({
  page,
  total,
  limit = PAGE_SIZE,
  onPageChange,
  onLimitChange,
  testId = "admin-pagination",
  label = "registros",
}) => {
  const totalPages = Math.max(1, Math.ceil((total || 0) / limit));
  const from = total === 0 ? 0 : (page - 1) * limit + 1;
  const to = Math.min(page * limit, total || 0);

  const pages = [];
  const start = Math.max(1, Math.min(page - 2, totalPages - 4));
  const end = Math.min(totalPages, start + 4);
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <div
      data-testid={testId}
      className="flex flex-col gap-3 border-t border-border/60 px-2 py-4 sm:flex-row sm:items-center sm:justify-between"
    >
      <div className="flex items-center gap-3">
        <p className="text-xs text-muted-foreground" data-testid={`${testId}-summary`}>
          {total === 0
            ? `Sin ${label}`
            : `Mostrando ${from}–${to} de ${total} ${label}`}
        </p>
        {onLimitChange && (
          <Select
            value={String(limit)}
            onValueChange={(v) => onLimitChange(Number(v))}
          >
            <SelectTrigger
              className="h-8 w-[70px] text-xs"
              data-testid={`${testId}-page-size`}
            >
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {PAGE_SIZES.map((s) => (
                <SelectItem key={s} value={String(s)}>
                  {s}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>

      <div className="flex items-center gap-1">
        <Button
          variant="outline"
          size="sm"
          className="h-8"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid={`${testId}-prev`}
        >
          <ChevronLeft className="h-4 w-4" />
          <span className="hidden sm:inline">Anterior</span>
        </Button>

        {pages.map((p) => (
          <Button
            key={p}
            variant={p === page ? "default" : "ghost"}
            size="sm"
            className="h-8 w-8 p-0 text-xs"
            onClick={() => onPageChange(p)}
            data-testid={`${testId}-page-${p}`}
          >
            {p}
          </Button>
        ))}

        <Button
          variant="outline"
          size="sm"
          className="h-8"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          data-testid={`${testId}-next`}
        >
          <span className="hidden sm:inline">Siguiente</span>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default AdminPagination;
